import UserInfo from 'components/common/UserInfo';
import classNames from 'classnames';
import styles from './CoursePreview.module.scss';
// import Icon from 'components/common/Icon';
import { useContext } from 'react';
import { CourseDetailsContext } from 'components/CourseDetails';
import CourseRatingView from 'components/common/CourseRatingView';
import RichContent from 'components/common/RichContent';

const CoursePreview = () => {
  const { courseInfo } = useContext(CourseDetailsContext);

  if (!courseInfo) return <></>;
  return (
    <div className={styles.previewContent}>
      <div className={styles.thumbImage}>
        {courseInfo.thumbnail_image_media?.url ? (
          <img src={courseInfo.thumbnail_image_media?.url || ''} />
        ) : (
          <span className={styles.noThumbText}>サムネイル</span>
        )}
      </div>
      <div
        className={classNames(styles.courseTitle, {
          [styles.blank]: !courseInfo.title,
        })}
      >
        {courseInfo.title ? courseInfo.title : 'タイトル'}
      </div>
      <div className={styles.creatorInfo}>
        <div style={{ pointerEvents: 'none' }}>
          <UserInfo user={courseInfo.user} avatarSize={36} badgeSize={32} />
        </div>
        <CourseRatingView
          count={courseInfo.review_summary?.count}
          rating={courseInfo.review_summary?.rating}
          className={styles.ratingSection}
        />
      </div>
      <div className={styles.courseDescription}>
        <RichContent text={courseInfo.description || ''} />
      </div>

      {/* {!courseInfo.benefits || courseInfo.benefits.length === 0 ? (
        <div className={styles.blankInfo}></div>
      ) : (
        <div className={styles.benefits}>
          {(courseInfo.benefits || [])
            .filter((benefit) => !!benefit.trim())
            .map((benefit, index) => {
              return (
                <div key={`benefit-${index}`} className={styles.benefit}>
                  <div className={styles.icon}>
                    <Icon name="done" width={18} height={18} />
                  </div>
                  <span className={styles.benefitContent}>{benefit}</span>
                </div>
              );
            })}
        </div>
      )} */}
    </div>
  );
};

export default CoursePreview;
